import axios from "axios";
import {
  ExperiencesShopOptionRequest,
  ExperiencesShopOptionResponse,
} from "redmond";
import { config } from "../../config";
import { experiencesShopOptionsApiPrefix } from "../paths";

export const fetchExperienceShopOptions = async (
  body: ExperiencesShopOptionRequest
): Promise<ExperiencesShopOptionResponse> => {
  const res = await axios.post(experiencesShopOptionsApiPrefix, body, {
    baseURL: config.baseURL,
  });

  return res.data.value;
};
